import { Link } from "@StarberryUtils";
import PropTypes from "prop-types";
import React,{useEffect} from "react";
import {Col, Row, Container } from 'react-bootstrap';
import ReactMarkdown from "react-markdown"
import love from "../../images/local-love-new.png"
import { getSrc } from "gatsby-plugin-image"
// import { InView } from "react-intersection-observer";
// import { motion } from "framer-motion";
import { GatsbyImage } from "gatsby-plugin-image";
import { LOCAL_LOVE_PAGE_URL} from '../common/site/constants'
const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.4,
        ease: [0.33, 1, 0.68, 1],
        duration: 0.4
      }
    }
  }

  const titleVariants = {
    hidden: {
      opacity: 0,
      y: 40 
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        ease: [0.33, 1, 0.68, 1],
        duration: 1
      }
    }
  }
const LocalLove = (props) => {
    return (
      <>
          <section
            className="local-love-module-main"
          >
          <Container>
              <Row>
                  <Col lg={6}>
                    <div variants={titleVariants}>
                      <div className="block-1">
                          <img loading="lazy" src={love} alt="Local love" className="mg-local-love"/>
                          {props.content ? <ReactMarkdown source={props.content} allowDangerousHtml /> : ''}
                          {props.label && props.link &&
                              <Link className="btn btn-primary" to={LOCAL_LOVE_PAGE_URL.alias}>{props.label}</Link>
                          }
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div variants={titleVariants}>
                      <div className="block-2">
                      <GatsbyImage image={props.image.childImageSharp.gatsbyImageData} />
                      </div>
                    </div>
                  </Col>
              </Row>
          </Container>
          </section>
        </>
    );
}

export default LocalLove
